export const candidateActionConstants = {
    QUERY_ACTION_REQUEST: 'QUERY_ACTION_REQUEST',
    QUERY_ACTION_FAILURE: 'QUERY_ACTION_FAILURE',
    QUERY_ACTION_SUCCESS: 'QUERY_ACTION_SUCCESS',

    DELETE_APPLICATIONS_REQUEST: 'DELETE_APPLICATIONS_REQUEST',
    DELETE_APPLICATIONS_FAILURE: 'DELETE_APPLICATIONS_FAILURE',
    DELETE_APPLICATIONS_SUCCESS: 'DELETE_APPLICATIONS_SUCCESS',
}